import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import { expandVideoLayout, shrankVideoLayout } from "../../../store/layouts/actions";
import { ApplicationState } from "../../../store";
import {LayoutState} from "../../../store/layouts/types";
import {CamerasState} from "../../../store/cameras/types";
import './style.scss';

interface Props {
    pane: number,
    cameraName: string | null,
    content?: string
}

const TitleCameraComponent:React.FC<Props> = ({ pane, content, cameraName }) => {
    const { expandedVideoLayout, checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    // const { currentCameras } = useSelector<ApplicationState, CamerasState>(state => state.cameras);
    const dispatch = useDispatch();
    if (!cameraName) return null;
    // const { name } = currentCameras[pane];

    let classValues = typeof expandedVideoLayout === 'number' ? 'camera-title zoomed' : 'camera-title';
    if (checkedPane === pane) classValues = classValues + ' checked';

    const handler = (e: React.MouseEvent) => {
        if (checkedPane === pane) {
            e.stopPropagation();
            expandedVideoLayout === pane ? dispatch(shrankVideoLayout()) : dispatch(expandVideoLayout(pane));
        }
    };

    return (
        <div className={classValues}
             onClick={handler}
        >
            { content ? content : cameraName }
        </div>
    )
};

export default  TitleCameraComponent